const xlsx = require("xlsx");

const Xlsexport = async (rows, col, wd, model) => {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        alert("Nessun dato da esportare.");
        return;
    }
    if (rows.length > 200000) { 
        alert("Hai superato il limite massimo per l'export.");
        return;
    }

    // Determine if all columns should be exported (when model is empty or not provided)
    const isModelEmpty = !model || typeof model !== 'object' || Object.keys(model).length === 0;

    // Filter columns that should be exported based on visibility model
    const visibleCols = col.filter((c) => {
        if (isModelEmpty) return true;
        return model[c.field] !== false;
    });

    if (visibleCols.length === 0) {
        alert("Nessuna colonna visibile da esportare.");
        return;
    }

    // Create header row with human readable headerName or field
    const headerRow = visibleCols.map((c) => c.headerName || c.field);

    // Extract row data values matching visible fields without mutating original row objects
    const dataRows = rows.map((row) =>
        visibleCols.map((c) => {
            const val = row[c.field];
            return (val !== null && val !== undefined) ? val : "";
        })
    );

    const output = [headerRow, ...dataRows];

    const workbook = xlsx.utils.book_new();
    const worksheet = xlsx.utils.aoa_to_sheet(output);
    worksheet['!cols'] = Array(visibleCols.length).fill({ wch: wd || 30 });
    xlsx.utils.book_append_sheet(workbook, worksheet, "Risultati");
    return xlsx.writeFile(workbook, "Export.xlsx");
};

export default Xlsexport;